import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { PaymentsApi, RequestStrategyEnum, type GetRequisitesResponse } from '@shared/api';

interface UseRequisitesStore {
  data: GetRequisitesResponse[];
  loading: boolean;
  error: string | null;
  getRequisites: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useRequisitesStore = create<UseRequisitesStore>((set) => ({
  loading: false,
  data: [],
  error: null,

  getRequisites: ApiUtils.wrapperApi(async (signal) => {
    try {
      set({ loading: true, error: null });
      const result = await PaymentsApi.getRequisites(signal);
      set({ data: result || [], loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ data: [], loading: false, error: null }),
}));
